import React from 'react';

import { BackButton } from '../BackButton';
import { Content, PageTitleContainer } from './styles';

type PropTypes = {
  children?: React.ReactNode;
  onBackClick?: () => void;
};

const PageTitle = ({ children = null, onBackClick }: PropTypes): JSX.Element => (
  <PageTitleContainer>
    {onBackClick && <BackButton onBackClick={onBackClick} />}
    <Content>{children}</Content>
  </PageTitleContainer>
);

export default PageTitle;
